import {UseFormSetValue} from "react-hook-form";
import {
    CreateCorrespondentInterface
} from "../../../../customer/correspondent/create/interface/CreateCorrespondentInterface";
import {BasicClientInfoType, SearchAccountType} from "../../../../customer/correspondent/detail/interface";
import {useReadAccountBasicInfo} from "../../../../order/orders/create/hooks/useReadAccountBasicInfo";
import {useReadAccountShipmentInfo} from "../../../../order/orders/create/hooks/useReadAccountShipmentInfo";
import {SearchContactType} from "../../../../customer/contact/interface";
import {useUser} from "../../../../../util/userContext/UserContext";
import {PcsDetailType} from "../interface";
import {useLocation} from "react-router-dom";
import moment from "moment/moment";

export default function useSetPurchaseValue() {
    const {state} = useLocation()
    const {user} = useUser();

    const {mutateAsync: mutateAsyncReadAccountBasicInfo} = useReadAccountBasicInfo()
    const {mutateAsync: mutateAsyncReadAccountShipmentInfo} = useReadAccountShipmentInfo()

    function adjustToValidDateWithMoment(dateString: string) {
      if (!dateString) return "";
    
      const m = moment(dateString, "YYYY-MM-DD", true);
    
      // 유효한 날짜면 그대로 반환
      if (m.isValid()) {
        return dateString;
      }
    
      // 유효하지 않다면 연/월/일 분해
      const [year, month, day] = dateString.split("-").map(Number);
    
      // 해당 월의 말일
      const lastDay = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
    
      // 말일로 보정
      return moment(
        `${year}-${month}-${Math.min(day, lastDay)}`,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
    }
    
    const setContact = (item: SearchContactType, setValue: UseFormSetValue<PcsDetailType>) => {
        mutateAsyncReadAccountBasicInfo(item.parentcustomeridValue).then(res1 => {
            mutateAsyncReadAccountShipmentInfo({
                accountId: item.parentcustomeridValue,
                chargeName: "",
                name: "",
                defaultContact: "",
                customerCategoryName: "",
                industryName: "",
            }).then(res2 => {
                const basicInfo = res1.result as BasicClientInfoType
                const shipmentInfo = res2.result as SearchAccountType

                // 고객사
                setValue("newLEnduserValue", basicInfo?.accountId ?? "");
                setValue("enduserName", basicInfo?.name ?? "");
                // 수신자
                setValue("newLRecipientValue", shipmentInfo?.recipient ?? "")
                setValue("recipientName", shipmentInfo?.recipientName ?? "")
                setValue("recipientMobile", shipmentInfo?.recipientMobilephone ?? "")
                // 발송지
                setValue("newLAddressValue", shipmentInfo?.shippingAddress ?? "")
                setValue("address1", shipmentInfo?.address1 ?? "");
                setValue("address2", shipmentInfo?.address2 ?? "");
                setValue("addressName", shipmentInfo?.addressName ?? "");
                // 계산서 담당자
                setValue("newLInvoiceAgentValue", shipmentInfo?.taxInvoicePerson ?? "")
                setValue("taxCharge", shipmentInfo?.taxChargeName ?? "")
                setValue("taxMobile", shipmentInfo?.taxChargeMobilePhone ?? "")
                setValue("taxEmail", shipmentInfo?.taxChargeEmailAddress ?? "")
                // 수금예정일
                setValue("newDtEstimatedCollection", adjustToValidDateWithMoment('2025-02-30'))
                // NOTE: 수금메모 필요 없다고 해서 가림
                // 수금메모(세금계산서 비고)
                // setValue("newTxtCollection", shipmentInfo?.newTxtCollection ?? "")
            })
        })

        setValue("contactName", item.fullName ?? "")
    }

    const setAccount = (item: CreateCorrespondentInterface, setValue: UseFormSetValue<PcsDetailType>) => {
        mutateAsyncReadAccountShipmentInfo(item).then(res => {
            if (res.code === "0000") {
                const shipmentInfo = res.result as SearchAccountType

                if (setValue) {
                    // 고객사
                    setValue("newLEnduserValue", item?.accountId ?? "");
                    setValue("enduserName", item?.name ?? "");
                    // 수신자
                    setValue("newLRecipientValue", shipmentInfo?.recipient ?? "")
                    setValue("recipientName", shipmentInfo?.recipientName ?? "")
                    setValue("recipientMobile", shipmentInfo?.recipientMobilephone ?? "")
                    // 발송지
                    setValue("newLAddressValue", shipmentInfo?.shippingAddress ?? "")
                    setValue("address1", shipmentInfo?.address1 ?? "");
                    setValue("address2", shipmentInfo?.address2 ?? "");
                    setValue("addressName", shipmentInfo?.addressName ?? "");
                    // 계산서 담당자
                    setValue("newLInvoiceAgentValue", shipmentInfo?.taxInvoicePerson ?? "")
                    setValue("taxCharge", shipmentInfo?.taxChargeName ?? "")
                    setValue("taxMobile", shipmentInfo?.taxChargeMobilePhone ?? "")
                    setValue("taxEmail", shipmentInfo?.taxChargeEmailAddress ?? "")
                    // 수금예정일
                    setValue("newDtEstimatedCollection", adjustToValidDateWithMoment(shipmentInfo?.expectedReceiptDate ?? ""))
                    // NOTE: 수금메모 필요 없다고 해서 가림
                    // 수금메모(세금계산서 비고)
                    // setValue("newTxtCollection", shipmentInfo?.newTxtCollection ?? "")
                }
            }
        })
    }

    const setPurchaseInit = (setValue: UseFormSetValue<PcsDetailType>) => {
        if (user) {
            mutateAsyncReadAccountBasicInfo(user.companyId).then(res1 => {
                mutateAsyncReadAccountShipmentInfo({
                    accountId: user.companyId,
                    chargeName: "",
                    name: "",
                    defaultContact: "",
                    customerCategoryName: "",
                    industryName: "",
                }).then(res2 => {
                    const basicInfo = res1.result as BasicClientInfoType
                    const shipmentInfo = res2.result as SearchAccountType
                    const stateDetail: (PcsDetailType | undefined) = state.purchaseDetail


                    // 수주고객
                    setValue("newLContactValue", user.contactId)
                    setValue("contactName", user.contactName)
                    // 고객사
                    setValue("newLEnduserValue", basicInfo?.accountId ?? "");
                    setValue("enduserName", basicInfo?.name ?? "");
                    // 수신자
                    setValue("newLRecipientValue", shipmentInfo?.recipient ?? "")
                    setValue("recipientName", shipmentInfo?.recipientName ?? "")
                    setValue("recipientMobile", shipmentInfo?.recipientMobilephone ?? "")
                    // 발송지
                    /*if (state && state.isFromExternalProduct && state.purchaseDetail) {
                        setValue("newLAddressValue", state.purchaseDetail.newLAddressValue)
                        setValue("addressName", state.purchaseDetail.addressName)
                        setValue("postCode", state.purchaseDetail.postCode)
                        setValue("address1", state.purchaseDetail.address1)
                        setValue("address2", state.purchaseDetail.address2)
                    } else {
                        setValue("newLAddressValue", shipmentInfo?.shippingAddress ?? "")
                        setValue("address1", shipmentInfo?.address1 ?? "");
                        setValue("address2", shipmentInfo?.address2 ?? "");
                        setValue("addressName", shipmentInfo?.addressName ?? "");
                    }*/
                    // 계산서 담당자
                    setValue("newLInvoiceAgentValue", shipmentInfo?.taxInvoicePerson ?? "")
                    setValue("taxCharge", shipmentInfo?.taxChargeName ?? "")
                    setValue("taxMobile", shipmentInfo?.taxChargeMobilePhone ?? "")
                    setValue("taxEmail", shipmentInfo?.taxChargeEmailAddress ?? "")
                    // 수금예정일
                    setValue("newDtEstimatedCollection", adjustToValidDateWithMoment(shipmentInfo?.expectedReceiptDate ?? ""))
                    // NOTE: 수금메모 필요 없다고 해서 가림
                    // 수금메모(세금계산서 비고)
                    // setValue("newTxtCollection", shipmentInfo?.newTxtCollection ?? "")

                    // NOTE: 외부 상품 -> 구매 시 state에 따라 관리되는 항목들
                    if (stateDetail) {
                        // 구매일자
                        setValue("purchaseOrderDt", moment().format("YYYY-MM-DD"))
                        // 발송요청일
                        setValue("newDtRequestShipment", moment(stateDetail.newDtRequestShipment).format("YYYY-MM-DD"))
                        // 발송방법
                        setValue("newPShipment", stateDetail.newPShipment)
                        setValue("purchaseOrderState", stateDetail.purchaseOrderState)

                        if (stateDetail.newLAddressValue === "" || stateDetail.newLAddressValue === "-1") {
                            // 주소 직접 입력(newLAddressValue === ""), 주소 검색(newLAddressValue === "-1") 시 신규 주소에 세팅
                            setValue("newLAddressValue", "")
                            setValue("addressName", stateDetail.addressName)
                            setValue("customPostcode", stateDetail.postCode)
                            setValue("customAddress1", stateDetail.address1)
                            setValue("customAddress2", stateDetail.address2)
                        } else {
                            // 배송지 선택 시 배송지, 주소1, 주소2에 세팅
                            setValue("newLAddressValue", stateDetail.newLAddressValue)
                            setValue("address1", stateDetail.address1);
                            setValue("address2", stateDetail.address2);
                            setValue("addressName", stateDetail.addressName);
                        }
                    } else {
                        // 주소1, 주소2에 세팅
                        setValue("newLAddressValue", shipmentInfo?.shippingAddress ?? "")
                        setValue("address1", shipmentInfo?.address1 ?? "");
                        setValue("address2", shipmentInfo?.address2 ?? "");
                        setValue("addressName", shipmentInfo?.addressName ?? "");
                    }
                })
            })
        }
    }

    return {setContact, setAccount, setPurchaseInit}
}